export default __webpack_public_path__ + "static/media/Q2_0_resized.1eada99c.jpg";